export function convertToWebProps({
  fontSize,
  fontWeight,
  lineHeight,
  letterSpacing,
}: {
  fontSize?: number;
  fontWeight?: number;
  lineHeight?: number;
  letterSpacing?: number;
}): Pick<React.CSSProperties, 'fontSize' | 'fontWeight' | 'lineHeight' | 'letterSpacing'> {
  // If a size is provided, use it.
  // Fallback on 'inherit' for all other cases.
  return {
    fontSize: fontSize ? `${fontSize}px` : 'inherit',
    fontWeight: fontWeight ?? 'inherit',
    lineHeight: lineHeight ? `${lineHeight}px` : 'inherit',
    letterSpacing: letterSpacing ? `${letterSpacing}em` : 'inherit',
  };
}
